import { useEffect, useState, useCallback } from 'react'
import { useUserSummary } from './useUserSummary'

const LOCALE_PLACEHOLDER = '{country}'

const loadBuyapowaSDK = (callback) => {
    const existingScript = document.getElementById('buyapowasdk')
    if (!existingScript) {
        const script = document.createElement('script')
        script.src = 'https://cdn.co-buying.com/embedding.min.js'
        script.id = 'buyapowasdk'
        document.body.appendChild(script)
        script.onload = () => {
            if (callback) callback()
        }
    }
    if (existingScript && callback) callback()
}

const useBuyapowaObserver = (elemId, mutationType, callback) => {
    useEffect(() => {
        const buyapowaObserver = new MutationObserver((mutationsList, observer) => {
            if (mutationsList.some((mutation) => mutation.type === mutationType)) {
                callback(observer)
            }
        })

        const elem = document.getElementById(elemId)

        if (elem) {
            buyapowaObserver.observe(elem, { [mutationType]: true })

            return () => buyapowaObserver.disconnect()
        }
    }, [])
}

const useBuyapowaLoading = ({ rootElem, errorElem }) => {
    const [loading, setLoading] = useState(true)

    const observerCallback = useCallback((observer) => {
        setLoading(false)
        observer.disconnect()
    }, [])

    useBuyapowaObserver(rootElem, 'childList', observerCallback)

    useBuyapowaObserver(errorElem, 'attributes', observerCallback)

    return loading
}

export const useBuyapowa = ({
    language: locale,
    country,
    rootElem,
    errorElem,
    buyapowaCampaign,
    buyapowaURL,
    buyapowaMarket,
}) => {
    if (!buyapowaURL || !buyapowaCampaign) return

    const userSummary = useUserSummary()
    const campaign = buyapowaCampaign.replace(LOCALE_PLACEHOLDER, country)
    const url = buyapowaURL.replace(LOCALE_PLACEHOLDER, country)
    const market = buyapowaMarket.replace(LOCALE_PLACEHOLDER, country)

    useEffect(() => {
        if (userSummary) {
            loadBuyapowaSDK(() => {
                // buyapowaURL: https://bp.mrporter.com or https://bp-au.theoutnet.com
                // buyapowaCampaign: 'mrporter_raf1' or 'outnet_{country}_raf1'
                // buyapowaMarket: 'mrporter' or 'outnet-au'
                const buyapowa = new window.Buyapowa({ url, market }, rootElem, errorElem)

                const config = {
                    campaign,
                    locale,
                }
                buyapowa.embedReferAFriend(config)
            })
        }
    }, [userSummary])

    return useBuyapowaLoading({ rootElem, errorElem })
}

export const useBuyapowaReferred = ({
    country,
    language: locale,
    rootElem,
    errorElem,
    buyapowaCampaign,
    buyapowaURL,
    buyapowaMarket,
}) => {
    if (!buyapowaURL || !buyapowaCampaign) return

    const campaign = buyapowaCampaign.replace(LOCALE_PLACEHOLDER, country)
    const url = buyapowaURL.replace(LOCALE_PLACEHOLDER, country)
    const market = buyapowaMarket.replace(LOCALE_PLACEHOLDER, country)

    useEffect(() => {
        loadBuyapowaSDK(() => {
            // buyapowaURL: https://bp.mrporter.com or https://bp-au.theoutnet.com
            // buyapowaCampaign: 'mrporter_raf1' or 'outnet_{country}_raf1'
            // buyapowaMarket: 'mrporter' or 'outnet-au'
            const buyapowa = new window.Buyapowa({ url, market }, rootElem, errorElem)
            const config = { campaign, locale }

            buyapowa.embedReferAFriend(config)
        })
    }, [])

    return useBuyapowaLoading({ rootElem, errorElem })
}
